import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => ({
  documentClassifications: [],
  documentClassificationsLoading: false,

  documentExtractTemplates: [],
  documentExtractTemplatesLoading: false,
});

export default {
  namespaced: true,
  actions,
  mutations,
  state,
  getters,
};